import { hasValue } from "../helpers/common_functions";
import { apiGet, apiDelete, apiPost, apiPut } from './api_call/api_methods'
import { getHeaders, generateRandomString, getKonnectHeaders } from "./common";

export const fetchDevice = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/device/${deviceId}`,
            {
                method: "GET",
                headers: {
                    ...getHeaders(),
                    accept: "text/plain",
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch device.");
            return { success: false, error: "Failed to fetch device" };
        }
    } catch (error) {
        console.error("Error fetching device:", error);
        return { success: false, error: error.message };
    }
};

export const fetchOrganizationDevices = async (orgCode, include_profile_picture) => {
    try {
        if (!orgCode)
            return { success: false, error: "Organization code is required" };

        if (include_profile_picture === null || include_profile_picture === undefined)
            include_profile_picture = true;

        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/get_org_devices?OrgCode=${orgCode}&include_profile_picture=${include_profile_picture}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch CareWindow users.");
            return { success: false, error: "Failed to fetch organization devices" };
        }
    } catch (error) {
        console.error("Error fetching organization devices:", error);
        return { success: false, error: error.message };
    }
};

export const unenrollDevice = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/unlink_device_org?id=${deviceId}`,
            {
                method: "PUT",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Device successfully unenrolled." };
        } else {
            return { success: false, error: "Failed to unenroll the device." };
        }
    } catch (error) {
        console.error("Error unenrolling device:", error);
        return { success: false, error: error.message };
    }
};

export const fetchLinkedDevices = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/linked_devices/${deviceId}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch linked devices.");
            return { success: false, error: "Failed to fetch linked devices" };
        }
    } catch (error) {
        console.error("Error fetching linked devices:", error);
        return { success: false, error: error.message };
    }
};

export const fetchDeviceImage = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/device_image/${deviceId}`,
            {
                method: "GET",
                headers: {
                    ...getHeaders(),
                    accept: "application/json",
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch device image.");
            return { success: false, error: "Failed to fetch device image" };
        }
    } catch (error) {
        console.error("Error fetching device image:", error);
        return { success: false, error: error.message };
    }
};

export const updateDeviceName = async (deviceId, newName, recoveryEmail, preferredLang, shortName, KonnektSkypeid, isLeader) => {
    let url = `update?device_id=${deviceId}&name=${newName}`;
    if (preferredLang !== null && preferredLang !== undefined) {
        url += "&preferredLang=" + preferredLang
    }
    if (recoveryEmail !== null && recoveryEmail !== undefined) {
        url += "&recoveryEmail=" + recoveryEmail
    }
    if (shortName !== null && shortName !== undefined) {
        url += "&shortName=" + shortName
    }
    if (KonnektSkypeid !== null && KonnektSkypeid !== undefined) {
        url += "&KonnektSkypeid=" + KonnektSkypeid
    }
    if (isLeader !== null && isLeader !== undefined) {
        url += "&isLeader=" + isLeader
    }


    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/${url}`,
            {
                method: "POST",
                headers: {
                    accept: "*/*",
                    portalscope: "b3NMWOVzfdRUjrW",
                    validatereq: generateRandomString(30),
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Name updated successfully!" };
        } else {
            return { success: false, error: "Failed to update name" };
        }
    } catch (error) {
        console.error("Error updating name:", error);
        return { success: false, error: "An error occurred while updating name" };
    }
};

export const updateDeviceAccountId = async (deviceId, newAccountId, timeZone) => {
    let url = `${process.env.REACT_APP_DEVICE_API_URL}/update?device_id=${deviceId}`
    if (hasValue(newAccountId))
        url = url + `&account_id=${newAccountId}`
    try {
        const response = await fetch(
            url,
            {
                method: "POST",
                headers: {
                    accept: "*/*",
                    portalscope: "b3NMWOVzfdRUjrW",
                    validatereq: generateRandomString(30),
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Name updated successfully!" };
        } else {
            return { success: false, error: "Failed to update name" };
        }
    } catch (error) {
        console.error("Error updating name:", error);
        return { success: false, error: "An error occurred while updating name" };
    }
};

export const updateDeviceTimeZone = async (objTZ) => {
    return apiPost({ endpoint: `${process.env.REACT_APP_DEVICE_API_URL}/update_timezone`, body: objTZ, successMessage: "updated!", errorMessage: "Failed to update" })
};

export const getTimeZones = async () => {
    return apiGet({ endpoint: `${process.env.REACT_APP_DEVICE_API_URL}/get_time_zones` })
};

export const updateDeviceAvatarAndAccountName = async (deviceId, imageFile, accountName) => {
    try {
        const formData = new FormData();
        formData.append("file", imageFile);

        let url = `${process.env.REACT_APP_DEVICE_API_URL}/update?device_id=${deviceId}`

        if (accountName) {
            url = url + `&account_name=${accountName}`
        }

        const response = await fetch(
            url,
            {
                method: "POST",
                headers: {
                    accept: "*/*",
                    portalscope: "b3NMWOVzfdRUjrW",
                    validatereq: generateRandomString(30),
                },
                credentials: "include",
                body: formData,
            }
        );

        if (response.ok) {
            return {
                success: true,
                message: "Profile picture updated successfully!",
            };
        } else {
            return { success: false, error: "Failed to update profile picture" };
        }
    } catch (error) {
        console.error("Error updating profile picture:", error);
        return {
            success: false,
            error: "An error occurred while updating profile picture",
        };
    }
};

export const generateDeepLink = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/generate_deep_link/${deviceId}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to generate deep link.");
            return { success: false, error: "Failed to generate deep link" };
        }
    } catch (error) {
        console.error("Error generating deep link:", error);
        return { success: false, error: error.message };
    }
};

// 解除设备配对
export const unpairDevice = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/unpair?id=${deviceId}`,
            {
                method: "POST",
                headers: getHeaders(),
                body: JSON.stringify({ id: deviceId }),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Device unpaired successfully!" };
        } else {
            console.error("Failed to unpair device.");
            return { success: false, error: "Failed to unpair device." };
        }
    } catch (error) {
        console.error("Error unpairing device:", error);
        return {
            success: false,
            error: "An error occurred while unpairing the device.",
        };
    }
};

// 发送邀请邮件
export const sendInvite = async (deviceId, email, inviteLink) => {
    try {
        const requestBody = {
            deviceID: deviceId,
            emailTo: email,
            inviteLink: inviteLink,
        };

        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/send_invite`,
            {
                method: "POST",
                headers: getHeaders(),
                body: JSON.stringify(requestBody),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Sent successfully" };
        } else {
            return { success: false, error: "Failed to send" };
        }
    } catch (error) {
        console.error("Error sending invite:", error);
        return { success: false, error: "Error occurred" };
    }
};

// 生成临时链接
export const generateTemporaryLink = async (deviceId, expiryTime) => {
    try {
        const requestBody = {
            expiryTime: expiryTime,
            deviceId: deviceId,
        };

        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/VideoCallInvite`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    accept: "text/plain",
                },
                body: JSON.stringify(requestBody),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            const errorData = await response.text();
            console.error("API Error:", errorData);
            return { success: false, error: "Failed to generate temporary link" };
        }
    } catch (error) {
        console.error("Error generating temporary link:", error);
        return {
            success: false,
            error: "An error occurred while generating the temporary link",
        };
    }
};

export const resetDevice = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/reset_device?device_id=${deviceId}`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    accept: "*/*",
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Device reset successfully!" };
        } else {
            console.error("Failed to reset device");
            return { success: false, error: "Failed to reset device" };
        }
    } catch (error) {
        console.error("Error resetting device:", error);
        return {
            success: false,
            error: "An error occurred while resetting the device",
        };
    }
};

export const HardresetDevice = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/hard_reset_device?device_id=${deviceId}`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    accept: "*/*",
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Device hard reset successfully!" };
        } else {
            console.error("Failed to hard reset device");
            return { success: false, error: "Failed to hard reset device" };
        }
    } catch (error) {
        console.error("Error resetting device:", error);
        return {
            success: false,
            error: "An error occurred while resetting the device",
        };
    }
};

export const fetchDeviceSettings = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/get_settings?id=${deviceId}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch settings");
            return { success: false, error: "Failed to load check-in settings" };
        }
    } catch (error) {
        console.error("Error fetching settings:", error);
        return { success: false, error: "Failed to load check-in settings" };
    }
};

export const fetchCaseNotes = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/device_case_notes/${deviceId}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (!response.ok) {
            return {
                success: false,
                error: `Failed to fetch case notes: ${response.status}`,
            };
        }

        const data = await response.json();
        return {
            success: true,
            data,
        };
    } catch (error) {
        console.error("Error fetching case notes:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};

export const updateCaseNotes = async (deviceId, caseNotes) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_DEVICE_API_URL}/update_case_notes`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                deviceId: deviceId,
                caseNotes: caseNotes,
            }),
        });

        if (!response.ok) {
            console.error(
                `Failed to update case notes: ${response.status}`,
                response
            );
            return {
                success: false,
                error: `Failed to update case notes: ${response.status}`,
            };
        }

        return {
            success: true,
            message: "Case notes updated successfully",
        };
    } catch (error) {
        console.error("Error updating case notes:", error);
        return {
            success: false,
            error: error.message,
        };
    }
};

export const updateDeviceSetting = async (setting, deviceId, value) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/update_setting`,
            {
                method: "POST",
                headers: getHeaders(),
                body: JSON.stringify({
                    id: setting.id,
                    deviceId: deviceId,
                    name: setting.name,
                    friendlyName: setting.friendlyName,
                    value: value,
                }),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true };
        } else {
            return { success: false, error: "Failed to update settings" };
        }
    } catch (error) {
        console.error("Error updating setting:", error);
        return { success: false, error: error.message };
    }
};

export const muteParticipant = async (deviceId, isMute = true) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/call/mute_device`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    mute: isMute,
                    device_id: deviceId,
                }),
            }
        );

        if (response.ok) {
            return {
                success: true,
                message: isMute
                    ? "Device muted successfully!"
                    : "Device unmuted successfully!",
            };
        } else {
            console.error(
                `Failed to ${isMute ? "mute" : "unmute"} device: ${deviceId}, status: ${response.status
                }`
            );
            return {
                success: false,
                error: `Failed to ${isMute ? "mute" : "unmute"} device`,
            };
        }
    } catch (error) {
        console.error(
            `Error ${isMute ? "muting" : "unmuting"} participant:`,
            error
        );
        return { success: false, error: error.message };
    }
};

export const resendNotification = async (
    callerName,
    deviceId,
    groupOrEventId,
    isGroupCall
) => {
    try {
        const requestBody = {
            callerName: callerName,
            deviceId: deviceId,
            eventId: isGroupCall ? groupOrEventId : groupOrEventId,
        };

        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/call/resend_notificaiton`,
            {
                method: "POST",
                headers: {
                    ...getHeaders(),
                    "Content-Type": "application/json",
                    accept: "*/*",
                },
                body: JSON.stringify(requestBody),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Notification resent successfully!" };
        } else {
            console.error("Failed to resend notification.");
            return { success: false, error: "Failed to call the device again" };
        }
    } catch (error) {
        console.error("Error resending notification:", error);
        return { success: false, error: error.message };
    }
};


export const fetchUnifiedCallLogs = async (deviceId, params = {}) => {
    try {
        const query = new URLSearchParams();
        if (params.page) query.set("page", params.page);
        if (params.page_size) query.set("page_size", params.page_size);
        if (params.call_type) query.set("call_type", params.call_type);
        if (params.call_outcome) query.set("call_outcome", params.call_outcome);
        if (params.direction) query.set("direction", params.direction);
        if (params.from_date) query.set("from_date", params.from_date);
        if (params.to_date) query.set("to_date", params.to_date);
        if (params.sort_order) query.set("sort_order", params.sort_order);
        if (params.search) query.set("search", params.search);
        if (params.classification) query.set("classification", params.classification);

        const qs = query.toString();
        const url = `${process.env.REACT_APP_CALLLOGS_API_URL}/device/${deviceId}${qs ? `?${qs}` : ""}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                portalscope: "b3NMWOVzfdRUjrW",
                validatereq: generateRandomString(30),
            },
            credentials: "include",
        });

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch unified call logs");
            return { success: false, error: "Failed to fetch call logs" };
        }
    } catch (error) {
        console.error("Error fetching unified call logs:", error);
        return { success: false, error: error.message };
    }
};

export const fetchCallRecordings = async (deviceId, user_id) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/call_recordings?device_id=${deviceId}&user_id=${user_id}`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    portalscope: "b3NMWOVzfdRUjrW",
                    validatereq: generateRandomString(30),
                },
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch call recordings");
            return { success: false, error: "Failed to fetch call recordings" };
        }
    } catch (error) {
        console.error("Error fetching call recordings:", error);
        return { success: false, error: error.message };
    }
};

export const fetchKonnektInvitee = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/get_invitee/${deviceId}`,
            {
                method: "GET",
                headers: getKonnectHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data };
        } else {
            console.error("Failed to fetch linked devices.");
            return { success: false, error: "Failed to fetch linked devices" };
        }
    } catch (error) {
        console.error("Error fetching linked devices:", error);
        return { success: false, error: error.message };
    }
};

export const updateKonnectID = async (deviceId, newKonnectID) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/update_konnect_id?device_id=${deviceId}&new_konnekt_id=${newKonnectID}`,
            {
                method: "POST",
                headers: getKonnectHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Konnekt ID updated successfully!" };
        } else {
            return { success: false, error: "Failed to update Konnekt ID" };
        }
    } catch (error) {
        console.error("Error updating name:", error);
        return { success: false, error: "An error occurred while updating konnekt id." };
    }
};

export const JoinKonnectDevices = async (requestBody) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/merge_konnekt_family`,
            {
                method: "POST",
                headers: getKonnectHeaders(),
                body: JSON.stringify(requestBody),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Konnekt ID updated successfully!" };
        } else {
            return { success: false, error: "Failed to update Konnekt ID" };
        }
    } catch (error) {
        console.error("Error :", error);
        return { success: false, error: "An error occurred while updating konnekt id." };
    }
};

export const UpdateKonnektContact = async (requestBody) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/update_konnect_contact`,
            {
                method: "POST",
                headers: getKonnectHeaders(),
                body: JSON.stringify(requestBody),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Contact updated successfully!" };
        } else {
            return { success: false, error: "Failed to update" };
        }
    } catch (error) {
        console.error("Error :", error);
        return { success: false, error: "An error occurred while updating the contact." };
    }
};

export const DeleteKonnektInvitation = async (invite_id) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/invitation/${invite_id}`,
            {
                method: "DELETE",
                headers: getKonnectHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true, message: "Contact invitation removed!" };
        } else {
            return { success: false, error: "Failed to remove invitation" };
        }
    } catch (error) {
        console.error("Error:", error);
        return { success: false, error: "An error occurred while removing the invitation." };
    }
};

export const getMediaSignUrl = async (file_name, file_type) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_DEVICE_API_URL}/get_aws_signed_url?file_name=${file_name}&file_type=${file_type}`,
            {
                method: "GET",
                headers: getHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            const data = await response.json();
            return { success: true, data: data, message: "Sign url generated successfully !" };
        } else {
            return { success: false, error: "Failed to generated sign url" };
        }
    } catch (error) {
        console.error("Error:", error);
        return { success: false, error: "Failed to generated sign url." };
    }
}

export const ImportKonnektContacts = async (deviceId) => {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/konnekt/import_konnekt_contacts?device_id=${deviceId}`,
            {
                method: "POST",
                headers: getKonnectHeaders(),
                credentials: "include",
            }
        );

        if (response.ok) {
            return { success: true };
        } else {
            console.error("Failed to fetch linked devices.");
            return { success: false, error: "Failed to fetch linked devices" };
        }
    } catch (error) {
        console.error("Error fetching linked devices:", error);
        return { success: false, error: error.message };
    }
};